import React from "react";
import data from "./data/foundationData";
import "./page-styles/foundation.scss";
import Header from "../components/header/Header";
import Hands from "../assets/SVG/hands-holding-heart.svg";
import CTA from "../components/CTA/CTA";
import AnimatedLine from "../components/animatedLine/AnimatedLine";
import Partners from "../components/partners/Partners";

function Foundation() {
  return (
    <main className="foundation page">
      <section className="foundation__landing">
        <Header
          h1={data.h1Genesis}
          content={data.genesis0}
          accordicon={data.genesis}
        />
        <div className="foundation__image-container">
          <img className="foundation__img" src={Hands} alt="" />
        </div>
        <Header h1={data.h1About} content={data.about} />
        <CTA />
      </section>

      <section>
        <div className="header-wrapper__h1 wrapper">
          <AnimatedLine text="Dane Fundacji" />
        </div>

        <div className="data-container">
          <p className="h3 wide">{data.info}</p>
          <p className="h3 bold wide">Dane do przelewu:</p>
          <p className="h4 medium">Numer konta:</p>
          <p className="h4 right">80 1240 4588 1111 0011 0099 1078</p>
          <p className="h4 medium">Tytuł przelewu:</p>
          <p className="h4 right">Darowizna</p>
          <p className="h4 medium">Nasze dane:</p>
          <p className="h4 right">
            FUNDACJA „MLEKO I MIÓD" <br /> os. Centrum C 3 / 18 <br /> 31-929
            Kraków
          </p>
          <p className="h3 bold wide">Dane do przelewu z zagranicy:</p>
          <p className="h4 medium">Kod SWIFT:</p>
          <p className="h4 right">PKOPPLPW</p>

          <p className="h4 medium">Numer IBAN:</p>
          <p className="h4 right">PL 80 1240 4588 1111 0011 0099 1078</p>
        </div>
      </section>
      <Partners />
    </main>
  );
}

export default Foundation;
